import axios from "axios";
// const host = "http://192.168.1.72:3002";
// const host = process.env.VUE_APP_URL_API;

let http = axios.create({
  // baseURL: "https://stonepro.cosmoscode.com.br/p/",
  // baseURL: "https://api-stonepro.cosmoscode.com.br/",
  baseURL: "https://api.cosmoscode.com.br/stonepro/",

  // baseURL: "https://perfectly-probable-kid.ngrok-free.app/",
  // baseURL: host,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${
      localStorage.token ? JSON.parse(localStorage.token) : ""
    }`
  }
});

http.interceptors.request.use(
  function(config) {
    config.headers.Authorization = `Bearer ${
      localStorage.token ? JSON.parse(localStorage.token) : ""
    }`;
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

export default http;
